import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { BusinessStatisticMainItemProps } from './types';

export const BusinessStatisticMainItem = (props: BusinessStatisticMainItemProps) => {
    const { displayValue, diffValue, diffDisplay, text } = props;

    return (
        <Flex width="100%" pt={1}>
            <Flex direction="row" spacing={1} alignItems="baseline">
                <Typography variant="title2" weight="bold">
                    {displayValue}
                </Typography>
                {diffValue ? (
                    <Typography
                        variant="caption"
                        color={diffValue >= 0 ? 'var(--color-success)' : 'var(--color-danger)'}
                    >
                        {diffDisplay}
                    </Typography>
                ) : (
                    ''
                )}
            </Flex>
            <Typography variant="body2" color="secondary" pt={0.5}>
                {text}
            </Typography>
        </Flex>
    );
};
